// extracted by mini-css-extract-plugin
module.exports = {"chevron_more":"style_chevron_more__1WWJa"};